/* eslint-disable max-len */
/* eslint-disable camelcase */
import i18n from 'i18next';

import getEnrollmentStatusOptions from './getEnrollmentStatusOptions';

const getVideoEnrollmentsModalFilters = ({ enrollmentsGroups }) => {
  const getGroupOptions = () => {
    const { data: groups } = enrollmentsGroups;
    return groups.map((group) => ({
      id: group.id,
      value: group.id,
      label: group.name,
    }));
  };

  return [
    {
      allow_multiple_selects: true,
      key: 'group_ids',
      label: 'User Groups',
      options: getGroupOptions(),
    },
  ];
};

const getVideoEnrollmentFilters = ({ enrolledUsers }) => {
  const {
    data: {
      meta: { maximum_version_number },
    },
  } = enrolledUsers;

  const getVideoVersions = () => {
    const versionArray = [];

    versionArray.push({
      id: 'draft',
      value: 0,
      label: i18n.t('draft'),
    });

    if (maximum_version_number) {
      for (
        let course_version_number = 1;
        course_version_number <= maximum_version_number;
        course_version_number += 1
      ) {
        versionArray.push({
          id: course_version_number,
          value: course_version_number,
          label: i18n.t('version-number', { number: course_version_number }),
        });
      }
    }

    return versionArray;
  };

  return [
    {
      key: 'course_version_number',
      label: i18n.t('version'),
      options: getVideoVersions(),
    },
    {
      key: 'status',
      label: i18n.t('status'),
      options: getEnrollmentStatusOptions({ enrolledUsers }),
    },
  ];
};

export default ({ enrollmentsGroups, enrolledUsers, isModalVariant }) =>
  isModalVariant
    ? getVideoEnrollmentsModalFilters({ enrollmentsGroups })
    : getVideoEnrollmentFilters({ enrolledUsers });
